<template>
  <base-label
    :data-qa="dataQa"
    :class="$props.class"
    :style="style"
  >
    <span
      v-if="label"
      :class="$style.label"
    >{{ label }}</span>
    <base-integer v-bind="$attrs" />
  </base-label>
</template>

<script>
import BaseInteger from '@/shared/legacy/ui/input/integer/integer.vue';
import BaseLabel from '@/shared/legacy/ui/label/label.vue';

export default {
  name: 'VInteger',
  components: {
    BaseLabel,
    BaseInteger
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: undefined
    },
    dataQa: {
      type: String,
      default: undefined
    },
    class: {
      type: [String, Array, Object],
      default: undefined
    },
    style: {
      type: [String, Array, Object],
      default: undefined
    }
  }
};
</script>

<style lang="less" module>
.label {
  display: block;
  margin-bottom: 3px;
}
</style>

<i18n lang="json">{}</i18n>
